<template>
  <!-- <div> -->
    <svg width="100%" :height="height+10" :x="x" :y="y" ref="svg" v-if="data.cols.length>0">
      <!-- Baseline -->
      <rect v-if="baseline"
        x="0" :y="getY(0)"
        height="1"
        :width="computedWidth"
        fill="#ddd"
        >
      </rect>
      <!-- Bars -->
      <rect v-for="(row, index) in data.rows[0]"
        :key="'bar'+index"
        :x="getX(index)"
        :y="getY(Math.max(row,0))"
        :height="Math.abs(getY(0)-getY(row))"
        :width="barThickness" 
        :fill="data.cols[index].color" />
      <!-- Labels -->
      <text v-for="(col, index) in data.cols"
        :key="'label'+index"
        :x="getX(index)+barThickness/2" 
        :y="height"
        text-anchor="middle"
        :font-size="fontSize"
        class="grid-label">
        {{capLength(col.label)}}
      </text>
      <!-- Values -->
      <text v-for="(row, index) in data.rows[0]"
        :key="'value'+index"
        :x="getX(index)+barThickness/2" 
        :y="getY(Math.max(row,0))-5"
        text-anchor="middle"
        :font-size="fontSize"
        class="grid-label">
        {{format(row)}}
      </text>
    </svg>
  <!-- </div> -->
</template>

<script>
import {scaleLinear} from 'd3' //scaleTime, , format
import debounce from 'debounce'

export default {
  name: 'ColumnChart',
  props: {
    data: Object,
    colors: Array,
    height: { type: Number, default: 200 },
    width: { type: String, default: '100%' },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    yRange: Array,
    suffix: String,
    fontSize: { type: Number, default: 16 },
    barMargin: { type: Number, default: 5 },
    plusminus: { type: Boolean, default: false },
    baseline: { type: Boolean, default: false },
    elipsis: { type: Boolean, default: true },
  },
  data () {
    return {
      computedWidth: 600,
      // barMargin: 5,
    }
  },
  methods: {
    fitProjection () {
      if (this.width != '100%') {
        this.computedWidth = this.width
      } else {
        this.computedWidth = this.$refs.svg.getBoundingClientRect().width
      }
    },
    format (number) {
      let prefix = ''
      
      if(this.plusminus) {
        if (number==0) {
          prefix = '±'
        } else if (number > 0) {
          prefix = '+'
        } else {
          prefix = ''
        }
      }
      
      return prefix + String(number).replace('.',',') + (this.suffix||'')
    },
    formatDate (str) {
      const date = new Date(str)
      return date.toLocaleDateString()
    },
    capLength (str) {
      let maxLength = parseInt(this.barThickness/9)
      if (str.length>maxLength&&this.elipsis) {
        return str.slice(0,maxLength) + '...'
      } else {
        return str
      }
    },
    getY (val) {
      let x = scaleLinear()
        .domain(this.yRangeComputed)
        .range([this.height-20, 20])
      return x(val)
    },
    getX (index) {
      return index*this.barThickness + index*this.barMargin
    }
  },
  computed: {
    yRangeComputed: function () {
      if (this.yRange) {
        return this.yRange
      } else {
        let min = Math.min(...this.data.rows[0])
        if (min > 0) { min = 0 }
        let max = Math.max(...this.data.rows[0])
        return [min, max]
      }
    },
    barThickness: function () {
      let n = this.data.cols.length
      // return n
      return (this.computedWidth - this.barMargin*(n-1))/n
    }
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))
    setTimeout(() => { this.fitProjection() }, 2000)
  },
  updated () {
    this.fitProjection()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>